<template>
  <div class="niste-clan">
    <div>{{ $t("not_part.case_text") }}</div>
    <router-link to="/cases">{{ $t("not_part.go_back") }}</router-link>
  </div>
</template>

<script>
export default {
    

}
</script>

<style>

</style>